<template>
  <div
    class="form-dialog"
    @click.self="outsideClick"
    @mousedown.self="outsideMousedown"
  >
    <mega-form
      :item="item"
      class="mega-form"
      :header="header"
      :disabled="disabled"
      :buttons="buttons"
      @save="save"
    >
      <slot />
    </mega-form>
  </div>
</template>

<script>
  export default {
    name: 'FormDialog',
    components: {
      'mega-form': () => import('@/views/admin/components/mega-form.vue'),
    },
    props: {
      item: {
        type: Object,
        default: () => null,
      },
      header: {
        type: String,
        default: 'Mega form header',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      buttons: {
        type: Array,
        default: () => [{ name: 'Save', callback: 'save' }],
      },
    },
    data() {
      return {
      };
    },
    apollo: {},
    computed: {},
    watch: {},
    mounted() {
      document.addEventListener('keyup', this.handler);
      for (const button of this.buttons) {
        this.$eventBus.$on(button.callback, (i) => {
          this.$emit(button.callback, i);
        });
      }
    },
    beforeDestroy() {
      document.removeEventListener('keyup', this.handler);
    },
    methods: {
      save(item) {
        this.$emit('save', item);
      },
      outsideClick() {
        if (this.mousedownOutside) {
          this.$emit('cancel');
        }
      },
      outsideMousedown() {
        this.mousedownOutside = true;
      },
      handler(e) {
        switch (e.keyCode) {
        case 13:
          this.$emit('enter-key');
          break;
        case 27:
          this.$emit('cancel');
          break;
        default:
          break;
        }
      },
    },
  };
</script>


<style lang="stylus" scoped>

  .form-dialog
    position: fixed
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    z-index: 666
    background-color: rgba(63, 70, 80, .7)

  .mega-form
    position: absolute
    margin: auto
    width: fit-content
    height: fit-content
    max-height: calc(100vh - 40px);
    left: 0
    right: 0
    top: 0
    bottom: 0
    overflow: auto

</style>
